import { Injectable } from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {InsoleMaterialDataService} from './insoleMaterial.data.service';
import {InsoleMaterialModel} from "../../../api/entity/insoleMaterial.model";
import {InsoleMaterialConverter} from "../../../api/entity/insoleMaterial.converter";

@Injectable()
export class InsoleMaterialDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<InsoleMaterialModel, InsoleMaterialConverter> {
    constructor(dataService: InsoleMaterialDataService, converter: InsoleMaterialConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): InsoleMaterialModel {
        return new InsoleMaterialModel();
    }
}
